var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                "label-col": _vm.labelCol1,
                "wrapper-col": _vm.wrapperCol1,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.persongroup.pgroupcode"],
                            prop: "pgroupcode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "common.autosystemcode"
                              ],
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.pgroupcode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "pgroupcode", $$v)
                              },
                              expression: "model.pgroupcode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.persongroup.pgroupname"],
                            prop: "pgroupname"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "cs.persongroup.pgroupname"
                              ]
                            },
                            model: {
                              value: _vm.model.pgroupname,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "pgroupname", $$v)
                              },
                              expression: "model.pgroupname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["common.sort"],
                            prop: "sort"
                          }
                        },
                        [
                          _c("a-input-number", {
                            attrs: {
                              placeholder: this.language["common.sort"],
                              min: 1,
                              max: 100
                            },
                            model: {
                              value: _vm.model.sort,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sort", $$v)
                              },
                              expression: "model.sort"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.activity.activityname"],
                            prop: "sysactivityid"
                          }
                        },
                        [
                          _c("a-Select", {
                            attrs: {
                              options: _vm.selectActivityList,
                              "allow-clear": "",
                              "show-search": "",
                              optionFilterProp: "children",
                              placeholder: this.language[
                                "cs.activity.activityname"
                              ]
                            },
                            model: {
                              value: _vm.model.sysactivityid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sysactivityid", $$v)
                              },
                              expression: "model.sysactivityid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }